export default __webpack_public_path__ + "static/media/banner-img.0fb38fd9.jpg";